import React from "react";

const LandingPage = () => {
  return <div />;
};

export default LandingPage;
